/* eslint-disable */
import { produce } from "immer";
import {
  UPLOAD_DOC_GETINTOUCH_START,
  UPLOAD_DOC_GETINTOUCH_SUCCESS,
  UPLOAD_DOC_GETINTOUCH_FAILURE,
  UPLOAD_DOC_GETINTOUCH_RESET,
} from "../actions/types";

const uploadGetInTouchDocReducer = (
  state = {
    uploadGetInTouchDocFetching: false,
    uploadGetInTouchDocData: {},
    uploadGetInTouchDocError: null,
  },
  action,
) => {
  switch (action.type) {
    case UPLOAD_DOC_GETINTOUCH_START:
      return produce(state, (draft) => {
        draft.uploadGetInTouchDocFetching = true;
      });
    case UPLOAD_DOC_GETINTOUCH_SUCCESS:
      return produce(state, (draft) => {
        draft.uploadGetInTouchDocFetching = true;
        draft.uploadGetInTouchDocData = action.data;
        draft.uploadGetInTouchDocFetching = false;
        draft.uploadGetInTouchDocError = null;
      });
    case UPLOAD_DOC_GETINTOUCH_FAILURE:
      return produce(state, (draft) => {
        draft.uploadGetInTouchDocFetching = false;
        draft.uploadGetInTouchDocError = action.error;
      });
    case UPLOAD_DOC_GETINTOUCH_RESET:
      return produce(state, (draft) => {
        draft.uploadGetInTouchDocFetching = false;
        draft.uploadGetInTouchDocError = null;
      });
    default:
      return state;
  }
};

export default uploadGetInTouchDocReducer;
